import { BaseOption, SelectValueType } from 'ui/selects';
import { SelectOption } from 'modules/queryBuilder/contexts/visualComponents';

export const getBaseOptionConverter = <T extends SelectValueType = string>(
  isMultiselect: boolean,
) => {
  const optionParser = (option: SelectOption<T>): BaseOption<T> => {
    const { value, title, badge, icon, subtitle, isDisabled, tooltipContent } = option;
    return {
      id: value.toString(),
      value,
      label: title,
      ...(isDisabled && { isDisabled }),
      ...(tooltipContent && { tooltipContent }),
      ...(badge && { Suffix: badge }),
      ...(icon && { Prefix: icon }),
      ...(subtitle && { [isMultiselect ? 'description' : 'doubleLine']: subtitle }), // multi select in ui/selectv2 uses "description" instead of "doubleline"
    };
  };
  return optionParser;
};
